<template>
  <input
    :class="
      checked.includes(value)
        ? 'bg-AkWhite border-0'
        : ''
    "
    v-if="Array.isArray(checked)"
    @click="click"
    class="checkbox-ghost h-4 w-4 flex-shrink-0 border border-AkWhite appearance-none md:h-6 md:w-6"
    type="checkbox"
    :checked="checked.includes(value)"
  />
  <input
    v-else
    :class="
      checked
        ? 'bg-AkWhite border-0'
        : ''
    "
    @click="$emit('input', !checked)"
    class="checkbox-ghost h-4 w-4 flex-shrink-0 border border-AkWhite appearance-none md:h-6 md:w-6"
    type="checkbox"
    :checked="checked"
  />
</template>

<script>
export default {
  name: 'CheckboxGhost',
  props: ['checked', 'value'],
  model: {
    prop: 'checked',
    event: 'input'
  },
  methods: {
    click () {
      if (this.checked.includes(this.value)) {
        this.checked.splice(this.checked.indexOf(this.value), 1)
      } else {
        this.checked.push(this.value)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
// input[type="checkbox"]:checked
[class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%2357c2dc' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-familles [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%2357c2dc' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-enseignants [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%2386d1c3' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-institutionnel [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%23ff7f7c' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-partenaires [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%23f886d1' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-musique [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%23bd8fd5' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")

.theme-rh [class^='checkbox-ghost']:checked
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 64 64' fill='%23ff7f7c' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M51.765 15L56 19.235 30.527 44.704l.061.061L26.353 49 8 30.649l4.235-4.235L26.292 40.47 51.765 15z'/%3e%3c/svg%3e")
</style>
